"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardItemFilter = exports.isSelectableItem = exports.isFocusableItem = exports.findIndexOfItemWithValue = exports.findSelectableItemIndex = exports.findFocusableItemIndex = void 0;
/** Intended only for use for searching lists of items. Does not wrap, skips item at `fromIndex`,
 * and returns `fromIndex` if no match is found.  */
function findIndex(items, fn, fromIndex, direction) {
    for (var index = fromIndex + direction; index >= 0 && index < items.length; index += direction) {
        if (fn(items[index])) {
            return index;
        }
    }
    return fromIndex;
}
function findFocusableItemIndex(items, fromIndex, direction) {
    return findIndex(items, isFocusableItem, fromIndex, direction);
}
exports.findFocusableItemIndex = findFocusableItemIndex;
function findSelectableItemIndex(items, fromIndex, direction) {
    return findIndex(items, isSelectableItem, fromIndex, direction);
}
exports.findSelectableItemIndex = findSelectableItemIndex;
function findIndexOfItemWithValue(items, value) {
    return findIndex(items, function (item) { return !!value && !item.group && item.value === value; }, -1, +1);
}
exports.findIndexOfItemWithValue = findIndexOfItemWithValue;
function isFocusableItem(item) {
    return !!item && !!item.value && !item.separator && !item.group;
}
exports.isFocusableItem = isFocusableItem;
function isSelectableItem(item) {
    return !!item && !item.disabled && isFocusableItem(item);
}
exports.isSelectableItem = isSelectableItem;
var caseInsensitiveValueMatch = function (item, filterValue) {
    return isFocusableItem(item) && item.value.toLowerCase().indexOf(filterValue.toLowerCase()) >= 0;
};
// tslint:disable-next-line:max-line-length
function standardItemFilter(items, filterValue, filterFn) {
    if (filterFn === void 0) { filterFn = caseInsensitiveValueMatch; }
    return items.filter(function (item) {
        return item.group || item.separator || filterFn(item, filterValue);
    }).filter(function (item, index, filteredItems) {
        return !(item.separator && index > 0 && filteredItems[index - 1].separator);
    }).filter(function (item, index, filteredItems) {
        return !(item.separator && (index === 0 || index === filteredItems.length - 1));
    });
}
exports.standardItemFilter = standardItemFilter;
//# sourceMappingURL=ListItemUtils.js.map